var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-10-05
 * @brief Local Clock 시계 컴포넌트
 * 10초당 AutoLogin check 및 로그인 연장 (조건에 따라)
 *
 ********************************************************************/
import { useCallback, useEffect, useRef } from "react";
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
// recoil state
import { authState, userInfoState } from "@recoil/userState";
//utils
import { urlState } from "@recoil/menuState";
import * as CONST from "@utils/Const";
import * as CUTIL from "@utils/commUtils";
import refreshTokenFn from "@utils/refreshToken";
import * as USERUTILS from "@utils/user/userUtils";
/**
 * @brief AutoLogin 컴포넌트
 * @param
 * @returns react components
 */
export function AutoLoginFn() {
    const isAuth = useRecoilValue(authState); // recoil value
    const userInfo = useRecoilValue(userInfoState); // recoil userState
    const setRecoilUserInfo = useSetRecoilState(userInfoState); // recoil userState
    const setRecoilUrl = useSetRecoilState(urlState);
    const resetRecoilUserInfo = useResetRecoilState(userInfoState);
    //
    const tokenTime = isAuth ? Date.parse(userInfo.loginInfo.tokenExpireTime) : Date.parse(CUTIL.curTimeString()); // UTC 기준
    const savedCallback = useRef();
    const callback = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        const keepLoginYn = localStorage.getItem(CONST.STR_KEEP_LOGIN_YN);
        const curTime = Date.parse(CUTIL.curTimeString()); // UTC 기준
        const diffSec = Math.round((tokenTime - curTime) / 1000);
        let isAutoRun = false;
        let isSAutoRun = false;
        isAutoRun = keepLoginYn == "Y" ? true : false;
        const lsUserId = localStorage.getItem(CONST.STR_USERID); // to localStorage
        const lsRefreshToken = localStorage.getItem(CONST.STR_REFRESHTOKEN); // to localStorage
        const lsRefreshTokenExpireTime = localStorage.getItem(CONST.STR_REFRESHTOKEN_EXPIRETIME); // to localStorage
        let data = null;
        if (isAutoRun) {
            if (isAuth) {
                if (diffSec > 0 && diffSec <= CONST.NUM_DIFFTIME_SEC) {
                    // 토큰 만료 10분전
                    isSAutoRun = true;
                }
                else {
                    // 로그인 유지이고....tokenExpireTime이 경과 안한경우
                }
            }
            else {
                // 로그인 유지이고....token이 없는 경우
                if (lsUserId != null && lsUserId.length > 0) {
                    isSAutoRun = true;
                }
            }
        }
        else {
            //keepLoginYn이 false일 경우 스토리지 초기화
            sessionStorage.removeItem(CONST.STR_TOKEN);
            sessionStorage.removeItem(CONST.STR_TOKEN_EXPIRETIME);
            localStorage.removeItem(CONST.STR_KEEP_LOGIN_YN);
            localStorage.removeItem(CONST.STR_USERID);
            localStorage.removeItem(CONST.STR_USERROLE);
            localStorage.removeItem(CONST.STR_REFRESHTOKEN);
            localStorage.removeItem(CONST.STR_REFRESHTOKEN_EXPIRETIME);
            localStorage.setItem("loginintro", CONST.URL_MAIN);
        }
        if (isSAutoRun) {
            data = yield refreshTokenFn(setRecoilUrl, resetRecoilUserInfo);
            if (data) {
                if (data.codeNum == 200) {
                    //sessionStorage
                    sessionStorage.setItem(CONST.STR_TOKEN, data.body.token);
                    sessionStorage.setItem(CONST.STR_TOKEN_EXPIRETIME, data.body.tokenExpireTime);
                    const loginInfo = {
                        role: userInfo.loginInfo.role,
                        token: data.body.token,
                        tokenExpireTime: data.body.tokenExpireTime,
                        refreshToken: lsRefreshToken,
                        refreshTokenExpireTime: lsRefreshTokenExpireTime,
                    };
                    (() => __awaiter(this, void 0, void 0, function* () {
                        // IFFE(Immediately Invoked Function Expression)은 함수가 정의되자마자 실행되는 자바스크립트 기술입니다.
                        const detailUserInfo = yield USERUTILS.getDetailUserInfoR(loginInfo);
                        setRecoilUserInfo({
                            loginTime: detailUserInfo.loginTime,
                            userId: detailUserInfo.userId,
                            email: detailUserInfo.email,
                            userName: detailUserInfo.userName,
                            phoneNumber: detailUserInfo.phoneNumber,
                            companyName: detailUserInfo.companyName,
                            zoneName: detailUserInfo.zoneName,
                            department: detailUserInfo.department,
                            role: detailUserInfo.role,
                            language: detailUserInfo.language,
                            classificationCode: detailUserInfo.classificationCode,
                            classification: detailUserInfo.classification,
                            agreeMailReceipt: detailUserInfo.agreeMailReceipt,
                            agreeTos: detailUserInfo.agreeTos,
                            agreePersonalInfo: detailUserInfo.agreePersonalInfo,
                            agreeData: detailUserInfo.agreeData,
                            userIdPk: detailUserInfo.userIdPk,
                            isAutomatedNickName: detailUserInfo.isAutomatedNickName,
                            nickName: detailUserInfo.nickName,
                            userRank: detailUserInfo.userRank,
                            userImage: detailUserInfo.userImage,
                            loginInfo: loginInfo,
                        });
                    }))();
                }
                else {
                    // need error handle
                }
            }
        }
    }), [isAuth, userInfo, tokenTime, setRecoilUserInfo]);
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        let id = setInterval(tick, 60000);
        return () => clearInterval(id);
    }, []);
}
export default AutoLoginFn;
